import { useEffect, useState } from "react";
// Import React FilePond
import FilePondPluginImageExifOrientation from "filepond-plugin-image-exif-orientation";
import FilePondPluginImagePreview from "filepond-plugin-image-preview";
import { registerPlugin } from "react-filepond";
import colis from "../../assets/images/colis.png";
// Import the plugin code
import { UploadIcon } from "@radix-ui/react-icons";
import FilePondPluginImageResize from "filepond-plugin-image-resize";
import { useForm } from "react-hook-form";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import { HOME } from "../../Utils/Utils";
import {
  ADD_LIVRAISON,
  LISTE_PARAMETRE_CONFIG,
  RECHERCHER_NUMERO_FTTH,
} from "../../Utils/constant";
import { store } from "../../services/service";
import { useConfigStore } from "../../store/ConfigStore";
import { useGlobalStore } from "../../store/store";
import BarcodeScanner from "../CodeScan";
import { SubmitButton } from "../Widget/SubmitButton";

// Register the plugins
registerPlugin(
  FilePondPluginImageExifOrientation,
  FilePondPluginImagePreview,
  FilePondPluginImageResize,
);
const TYPE_VENTE = {
  AVEC_EQUIPEMENT: true,
  SANS_EQUIPEMENT: false,
};

export const LivraisonForm = ({ numeroTicket, handleNext }) => {
  const navigate = useNavigate();
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm();
  const [isSubmit, setIsSubmit] = useState(false);
  const [bordereau, setBordereau] = useState([]);
  const [statusLivraison, setStatusLivraison] = useState(false);
  const [error, setError] = useState(null);
  const [ftth, setFtth] = useState(null);
  const [numeroSerie, setNumeroSerie] = useState(null);
  const [isExiting, setIsExiting] = useState(false);
  const [typeVente, setTypeVente] = useState(true);
  const numeroFtth = useGlobalStore();
  const param = useConfigStore();

  const handleChangeLivraison = (e) => {
    const selectedFiles = e.target.files;
    if (bordereau.length <= 0) {
      const newFiles = Array.from(selectedFiles);
      setBordereau((prevFiles) => [...prevFiles, ...newFiles]);
    } else {
      const newFiles = Array.from(selectedFiles);
      setBordereau(newFiles);
    }
  };

  const submit = (data) => {
    setError(null);
    setIsSubmit(true);
    const requestData = {
      ...data,
      numeroTicket: numeroTicket,
      numeroFtth: ftth?.numeroFtth,
      bordereau: bordereau[0],
      statusLivraison: "",
      venteAvecEquipement: typeVente,
    };
    store(ADD_LIVRAISON, "multipart/form-data", requestData)
      .then((res) => {
        if (res.status === 200) {
          setStatusLivraison(true);
          setIsSubmit(null);
          toast.success("Livraison effectué");
        }
      })
      .catch((err) => {
        setIsSubmit(false);
        setStatusLivraison(false);
        setError(err?.response?.data?.donnee);
      });
  };

  // Fonction pour gérer la sortie
  const handleExit = async () => {
    navigate(`${HOME}/identification`);
  };

  useEffect(() => {
    param.getData(LISTE_PARAMETRE_CONFIG);
    numeroFtth.getData(
      `${RECHERCHER_NUMERO_FTTH}?numeroTicket=${numeroTicket}`,
    );
  }, []);

  useEffect(() => {
    if (numeroFtth?.data?.donnee) {
      setFtth(numeroFtth?.data?.donnee);
    }
  }, [numeroFtth?.data]);

  return (
    <>
      {!statusLivraison ? (
        <form
          onSubmit={handleSubmit(submit)}
          className="shadow-sm border rounded w-full p-4 sm:p-6 lg:p-8"
        >
          <h1 className="text-amber-500 font-mtn text-base sm:text-lg lg:text-2xl font-semibold tracking-tight">
            Livraison de l'equipement
          </h1>
          <p className="text-red-600 text-xs mt-1">{error}</p>

          <div className="mt-4 sm:mt-6 space-y-4">
            {(param?.data?.CHAMPS_SN === "true" && !param?.loading) ||
            param?.data?.CHAMPS_SN === null ? (
              <label className="form-control w-full">
                <div className="mt-4 sm:mt-6">
                  <div className="flex gap-3 mt-2">
                    <button
                      type="button"
                      onClick={() => setTypeVente(TYPE_VENTE.AVEC_EQUIPEMENT)}
                      className={`flex-1 px-4 h-9 text-xs font-medium rounded-lg border ${
                        typeVente === TYPE_VENTE.AVEC_EQUIPEMENT
                          ? "bg-main text-black "
                          : "bg-white text-black"
                      }`}
                    >
                      Vente avec équipement
                    </button>
                    <button
                      type="button"
                      onClick={() => {
                        setTypeVente(TYPE_VENTE.SANS_EQUIPEMENT);
                        setNumeroSerie(null); // reset numéro série si on bascule
                      }}
                      className={`flex-1 px-4 h-9 text-xs font-medium rounded-lg border ${
                        typeVente === TYPE_VENTE.SANS_EQUIPEMENT
                          ? "bg-main text-black"
                          : "bg-white text-black"
                      }`}
                    >
                      Vente sans équipement
                    </button>
                  </div>
                </div>
                <div className="label -mb-1">
                  <span className="label-text text-sm sm:text-base">
                    Numéro série{" "}
                    {typeVente && <span className="text-red-500">*</span>}
                  </span>
                </div>
                <div className="flex flex-col gap-2 lg:flex-row lg:gap-1">
                  <input
                    {...register("numeroSerie", { required: typeVente })}
                    type="text"
                    value={numeroSerie}
                    onChange={(e) => {
                      setNumeroSerie(e.target.value);
                    }}
                    placeholder="Numéro de série l'équipement"
                    className="input input-bordered text-gray-500 w-full h-10 text-sm font-semibold"
                  />
                  <div className="flex items-center gap-2 w-full lg:w-auto">
                    <BarcodeScanner setResult={setNumeroSerie} />
                    {/* <span
                      onClick={() => {
                        numeroFtth.getData(
                          `${RECHERCHER_NUMERO_FTTH}?numero=${numeroSerie}&numeroTicket=${numeroTicket}`,
                        );
                      }}
                      disabled={!numeroSerie}
                      className="cursor-pointer shadow-none bg-main btn btn-sm font-normal h-10 text-xs flex-1 lg:flex-none whitespace-nowrap"
                    >
                      Rechercher un numero FTTH
                    </span> */}
                  </div>
                </div>
              </label>
            ) : (
              <div>
                {/* <span
                  onClick={() => {
                    numeroFtth.getData(
                      `${RECHERCHER_NUMERO_FTTH}?numero=&numeroTicket=${numeroTicket}`,
                    );
                  }}
                  className="cursor-pointer shadow-none bg-main btn btn-sm font-normal h-10 text-xs flex-1 lg:flex-none whitespace-nowrap"
                >
                  Rechercher un numero FTTH
                </span> */}
              </div>
            )}

            <label className="form-control w-full">
              <div className="label -mb-1">
                <span className="label-text text-sm sm:text-base">
                  IMSI SIM Pack Mobile <span className="text-red-500">*</span>
                </span>
              </div>
              <input
                {...register("imsi", { required: true })}
                type="text"
                placeholder="IMSI SIM"
                className="input input-bordered text-gray-500 w-full h-10 text-sm font-semibold"
              />
            </label>

            <label className="form-control w-full">
              <div className="label -mb-1">
                <span className="label-text font-medium text-sm sm:text-base">
                  Numéro FTTH - PID <span className="text-red-500">*</span>
                </span>
                <p className="text-xs text-red-600">{numeroFtth.error}</p>
              </div>
              <label className="bg-gray-100 text-sm h-10 grow text-gray-500 input input-bordered flex items-center gap-2">
                <p className="truncate">
                  {numeroFtth.loading
                    ? "en cours de recherche..."
                    : numeroFtth?.data?.donnee === null
                      ? "Aucun numéro FTTH trouvé"
                      : `${ftth?.numeroFtth ?? ""}`}
                </p>
              </label>
            </label>
          </div>

          <div className="mt-4">
            <label className="form-control w-full">
              <div className="label flex flex-col justify-start items-start gap-1.5">
                <span className="label-text font-medium text-gray-400 text-sm sm:text-base">
                  Bordereau de livraison
                </span>
                <div className="w-full">
                  {bordereau.length !== 0 ? (
                    bordereau.map((bordereauLivraison, index) => (
                      <div
                        key={index}
                        className="text-black py-12 sm:py-14 border-dashed border-2 bg-gray-200 border-gray-300 px-3 my-2 w-full rounded-md shadow-sm cursor-pointer"
                        style={{
                          background:
                            "url('" +
                            URL.createObjectURL(bordereauLivraison) +
                            "') no-repeat center/cover",
                        }}
                        onClick={() =>
                          document.getElementById("livraison").click()
                        }
                      ></div>
                    ))
                  ) : (
                    <div
                      className="text-black py-6 sm:py-8 border-dashed border-2 bg-gray-200 border-gray-300 px-3 my-2 w-full rounded-md shadow-sm cursor-pointer"
                      onClick={() =>
                        document.getElementById("livraison").click()
                      }
                    >
                      <div className="flex justify-center mb-3">
                        <UploadIcon className="w-5 h-5 sm:w-6 sm:h-6" />
                      </div>
                      <div>
                        <p className="text-center text-xs sm:text-sm mx-1">
                          Bordereau de livraison
                        </p>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </label>
          </div>
          <SubmitButton
            isSubmit={isSubmit}
            label={"Enregistrer la livraison"}
          />
        </form>
      ) : (
        <div className="flex justify-center my-16 sm:my-20 lg:my-28 w-full px-4">
          <div className="text-center">
            <img
              className="mx-auto w-16 h-16 sm:w-20 sm:h-20"
              src={colis}
              alt="Livraison effectuée"
            />
            <p className="font-light mt-2 text-sm sm:text-base">
              Livraison de l'equipement effectuée
            </p>
          </div>
        </div>
      )}
      <input
        type="file"
        accept="image/jpeg, image/png "
        hidden
        id="livraison"
        onChange={handleChangeLivraison}
      />
      <div className="w-full mt-4 px-4 sm:px-0">
        <hr />
        <div
          className="flex mt-4 justify-end"
          sx={{ display: "flex", flexDirection: "row", pt: 2 }}
        >
          <button
            onClick={handleExit}
            disabled={isSubmit !== null || isExiting}
            className={`bg-[#ffcb05] btn btn-sm py-1 px-3 sm:px-4 font-medium rounded-lg text-xs sm:text-sm ${
              isExiting ? "loading" : ""
            }`}
          >
            {isExiting ? "Fermeture..." : "Quitter"}
          </button>
        </div>
      </div>
    </>
  );
};
